import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Document } from './data-access/models/document.model';
import { DocumentsService } from './data-access/services/documents.service';

@Component({
  selector: 'app-documentation',
  standalone: true,
  imports: [CommonModule, FormsModule],
  template: `
  <div class="max-w-full">
      <div class="flex justify-between items-center mb-6">
        <h1 class="text-2xl font-semibold text-gray-900">Documentación</h1>
      </div>
      <p>Contenido en desarrollo...</p>
    </div>
  `,
  styles: []
})
export class DocumentationComponent implements OnInit {
  tabs: string[] = [];
  selectedTab = '';
  searchTerm = '';
  selectedFilter1 = 'Activos';
  selectedFilter2 = 'Todos';
  selectedDocument: Document | null = null;
  allDocuments: Document[] = [];

  constructor(private documentsService: DocumentsService) { }

  ngOnInit(): void {
    this.loadDocuments();
  }

  loadDocuments(): void {
    this.documentsService.getDocuments().subscribe({
      next: (documents) => {
        this.allDocuments = documents;

        this.tabs = [...new Set(
          documents.filter(doc => doc.is_active).map(doc => doc.agent_type)
        )];

        if (this.tabs.length > 0) {
          this.selectedTab = this.tabs[0];
        }
      },
      error: (error) => {
        console.error('Error cargando documentos:', error);
      }
    });
  }

  get filteredDocuments(): Document[] {
    let docs = this.allDocuments.filter(doc => doc.agent_type === this.selectedTab);

    if (this.selectedFilter1 === 'Activos') {
      docs = docs.filter(doc => doc.is_active);
    } else if (this.selectedFilter1 === 'Archivados') {
      docs = docs.filter(doc => !doc.is_active);
    }

    if (this.selectedFilter2 !== 'Todos') {
      docs = docs.filter(doc => doc.extension === this.selectedFilter2);
    }

    if (this.searchTerm) {
      docs = docs.filter(doc =>
        doc.name.toLowerCase().includes(this.searchTerm.toLowerCase())
      );
    }

    return docs;
  }

  selectDocument(doc: Document): void {
    this.selectedDocument = doc;
  }

  downloadDocument(): void {
    //
  }

  uploadNewVersion(): void {
    //
  }

  deleteDocument(): void {
    //
  }
}
